module.exports = __webpack_public_path__ + "static/img/zfb.1e7764d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zfb.jpg
// module id = mwvW
// module chunks = 1